import { createRouter, createWebHistory } from 'vue-router';
import help from '@/views/help.vue';
import supportPlatform from '../views/supportPlatform.vue';
import vip from '../views/VIP.vue';
import teamEdition from '../views/teamEdition.vue';

const routes = [
  {
    path: '/home',
    name: 'home',
    component: help,
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/help.vue'),
  },
  {
    path: '/supportPlatform',
    name: 'supportPlatform',
    component: supportPlatform, //支持平台
  },
  {
    path: '/vip',
    name: 'vip',
    component: vip,
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue'),
  },
  {
    path: '/teamEdition',
    name: 'teamEdition',
    component: teamEdition,
  },
  {
    path: '/regarding',
    name: 'regarding',
    component: () => import('../views/regarding.vue'),
  },
  {
    path: '/aiClip',
    name: 'aiClip',
    component: () => import('../views/aiClip.vue'),
  },
  {
    path: '/noAccount',
    name: 'noAccount',
    component: () => import('../views/noAccount.vue'),
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help.vue'),
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    component: () => import('../views/tutorial.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),  // 使用createWebHistory
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 滚动到顶部
  window.scrollTo(0, 0);
  next();
});

export default router;